var EMPTY_ARRAY = [];
var placeholderArray = [];
export function createIterable(data) {
  var iterable = EMPTY_ARRAY;
  var objectInfo = {
    index: -1,
    data: data,
    target: []
  };

  if (!data) {
    iterable = EMPTY_ARRAY;
  } else if (typeof data[Symbol.iterator] === 'function') {
    iterable = data;
  } else if (data.length > 0) {
    placeholderArray.length = data.length;
    iterable = placeholderArray;
  }

  return {
    iterable: iterable,
    objectInfo: objectInfo
  };
}
//# sourceMappingURL=iterable-utils.js.map